<template>
  <div class="container">
    <div class="row">
      <div class="col-lg-12 p-0">
        <div class="page-content">
          
          <!--
          <div class="main-banner">
            <div class="overlay-h1">
              <div class="row">
              <div class="col-lg-7">
                <div class="header-text">
                  <h6>SALAS DE ACCIÓN ARCADE</h6>
                  <h4>Descúbre la nueva<br>forma de <em>jugar</em></h4>
                  <h5 class="location2">En Terrassa, Cataluña</h5>
                  <div class="main-button">
                    <a href="#" @click.prevent="() => {$router.push('/booking')}">RESERVA AHORA</a>
                  </div>
                </div>
              </div>
              <div class="col-lg-5 image text-center p-4 cursor-pointer" @click="openModal">
                <img src="@/assets/images/PLAY2.svg" alt="" />
                <h2 class="video-shadow">VER VÍDEO</h2>
              </div>
            </div>
            </div>
          

          </div>
           ***** Banner Start ***** -->
           <section class="find-center">
              <h2>ENCUENTRA TU CENTRO</h2>
              <div class="center-options">
                <div class="center-box" @click="$router.push('/barcelona')">
                  <h3><i class="fa fa-location-dot"></i>Barcelona<br><span>VER PRECIOS</span></h3>
                </div>
                <div class="center-box" @click="$router.push('/coruna')">
                  <h3><i class="fa fa-location-dot"></i>A Coruña<br><span>VER PRECIOS</span></h3>
                </div>
                <div class="center-box" @click="$router.push('/terrassa')">
                  <h3><i class="fa fa-location-dot"></i>Terrassa<br><span>VER PRECIOS</span></h3>
                </div>
              </div>
          </section>
          <div class="overlay-h2">
            <div class="section-how">
            <div class="row">
              <div class="col-lg-12">
                <h2>¿CÓMO FUNCIONA?</h2>
              </div>
              <div class="row">
                <div class="col-lg-6">
                  <div class="item">
                    <p>
                      SPARK81 es un espacio de juegos arcade inmersivos donde cada sala alberga desafíos digitales para jugar en equipo.
                      <br>
                      Combina la acción de un videojuego con tecnología interactiva que te hace saltar, disparar, esquivar, correr…
                      <br>
                      Solo los mejores conseguirán llegar a lo más alto
                      del ránking. ¿Estás listo?
                    </p>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="row item2">
                    <div class="col-2">
                      <img src="@/assets/images/icon(2).png" alt="" />
                    </div>
                    <div class="col-10">
                      <h4>Forma equipo/s de 2 a 6 jugadores.</h4>
                    </div>
                  </div>
                  <div class="row item2 item-far">
                    <div class="col-2">
                      <img src="@/assets/images/icon(3).png" alt="" />
                    </div>
                    <div class="col-10">
                      <h4>Reserva desde web.</h4>
                    </div>
                  </div>
                  <div class="row item2 item-far">
                    <div class="col-2">
                      <img src="@/assets/images/icon(1).png" alt="" />
                    </div>
                    <div class="col-10">
                      <h4>Juega en turnos de 20 min en cada sala.</h4>
                    </div>
                  </div>
                  <div class="row item2 item-far">
                    <div class="col-2">
                      <img src="@/assets/images/icon(6).png" alt="" />
                    </div>
                    <div class="col-10">
                      <h4>Ven con ropa y calzado deportivo.</h4>
                    </div>
                    
                  </div>
                  <div class="row item2">
                    <div class="col-2">
                      <img src="@/assets/images/icon(7).png" alt="" />
                    </div>
                    <div class="col-10">
                      <h4>Intenta llegar a lo más alto del ránking.</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </div>

          <div class="most-popular">
            <div class="row">
              <div class="col-lg-12">
                <div class="heading-section">
                  <h4>LAS SALAS</h4>
                </div>
                <div class="row salas-select">
                  <div class="col-lg-9">
                    <div class="item3">
                      <Transition name="room" mode="out-in">
                        <img
                          :key="rooms[roomSelected]"
                          class="answer"
                          :src="rooms[roomSelected].room_src"
                          alt=""
                        />
                      </Transition>
                    </div>
                  </div>
                  <div class="col-lg-3">
                    <div
                      class="item2 cursor-pointer"
                      v-for="(room, index) in rooms"
                      :key="room"
                      :class="roomSelected == index ? 'siactive' : ''"
                      @click="changeRoomSelected(index)"
                    >
                      <img :src="room.icon_src" alt="" />
                      <h4>{{ room.name }}</h4>
                    </div>
                  </div>
                </div>
                <Transition name="room" mode="out-in">
                  <div
                    class="row"
                    v-if="rooms[roomSelected].challenges.length > 0"
                  >
                    <h3>RETOS</h3>
                  </div>
                  <div class="row" v-else>
                    <div class="col-lg-4 col-sm-6">
                      <h3>PRÓXIMAMENTE</h3>
                    </div>
                  </div>
                </Transition>
                <div class="col">
                  <Transition name="room" mode="out-in">
                    <div
                      class="row"
                      v-if="rooms[roomSelected].challenges.length > 0"
                    >
                      <TransitionGroup name="games" mode="out-in">
                        <div
                          class="col-lg-4 col-sm-6"
                          v-for="challenge in rooms[roomSelected].challenges"
                          :key="challenge"
                        >
                          <div class="item4" :key="challenge.name">
                            <h4>{{ challenge.name }}</h4>
                            <span>{{ challenge.description }}</span>
                          </div>
                        </div>
                      </TransitionGroup>
                    </div>
                  </Transition>
                </div>
              </div>
            </div>
          </div>

          <!-- ***** Sigue tu Progreso ***** -->
          <section class="track-progress">
            <div class="track-content">
              <h2>SIGUE TU PROGRESO</h2>
              <p>
                Con nuestra app, podrás revisar tus estadísticas, comparar resultados y
                desbloquear logros exclusivos.
              </p>
            </div>
            <div class="track-image">
              <img src="@/assets/images/App.png" alt="App SPARK81" />
            </div>
          </section>

          <!-- ***** Reseñas ***** -->
          <section class="reviews">
            <h2>RESEÑAS</h2>
            <div class="row review-container">
              <div class="review-box">
                <p class="review-text">
                  "Una experiencia fantástica. Muy recomendable para pasar un buen rato con grandes y pequeños […]" (Google)
                </p>
                <div class="review-meta">
                  <span class="stars">⭐⭐⭐⭐⭐</span>
                  <span class="source">— Julia Mundet</span>
                </div>
              </div>
              <div class="review-box">
                <p class="review-text">
                  "Una actividad super divertida y dinámica, tanto para competir como para colaborar en familia o con amigos […]" (Google)
                </p>
                <div class="review-meta">
                  <span class="stars">⭐⭐⭐⭐⭐</span>
                  <span class="source">— Sara Navas</span>
                </div>
              </div>
              <div class="review-box">
                <p class="review-text">
                  "Lo hemos pasado en grande […] juegos muy divertidos para hacer en familia […] el ambiente del sitio es genial." (Google)
                </p>
                <div class="review-meta">
                  <span class="stars">⭐⭐⭐⭐⭐</span>
                  <span class="source">— Alicia Álvarez</span>
                </div>
              </div>
            </div>

            <div class="row review-container">
              <div class="review-box">
                <p class="review-text">
                  "Muy divertido y sobre todo, diferente […] el tiempo se pasa volando y algunas pruebas son tan entretenidas que quieres repetirlas." (Google)
                </p>
                <div class="review-meta">
                  <span class="stars">⭐⭐⭐⭐⭐</span>
                  <span class="source">— Daniel López</span>
                </div>
              </div>
              <div class="review-box">
                <p class="review-text">
                  "Súper divertido […] todas las salas tienen juegos diferentes y muy entretenidos […] Recomendable 100%, volveremos para batir nuestra puntuación." (Google)
                </p>
                <div class="review-meta">
                  <span class="stars">⭐⭐⭐⭐⭐</span>
                  <span class="source">— Kaneki</span>
                </div>
              </div>
              <div class="review-box">
                <p class="review-text">
                  "¡Experiencia diferente y muy divertida! Cada sala es distinta […] algunas pruebas parecen sencillas pero te sorprenden […] acabamos reventados." (Google)
                </p>
                <div class="review-meta">
                  <span class="stars">⭐⭐⭐⭐⭐</span>
                  <span class="source">— Clara Gil Vila </span>
                </div>
              </div>
            </div>


          </section>

            <!-- ***** Regala SPARK81 ***** -->
            <section class="gift-spark">
              <div class="gift-text">
                <h2>REGALA SPARK81</h2>
                <p>
                  Sorprende a tus amigos y familiares con una experiencia inolvidable.
                  ¡Hazles un regalo que nunca olvidarán!
                </p>
                <div class="second-button">
                  <a href="#" @click.prevent="() => {$router.push('/booking')}">RESERVA TU PARTIDA</a>
                </div>
              </div>
              <div class="gift-image">
                <img src="@/assets/images/Regalo.png" alt="Regala Spark81" />
              </div>
            </section>
          <FAQs />
          <Subscribe />
          <!-- ***** Most Popular End ***** -->
        </div>
      </div>
    </div>
    <Modal :isOpen="isModalOpened" @modal-close="closeModal" name="first-modal">
      <template #content><iframe class="w-full aspect-video rounded-3xl" src="https://www.youtube.com/embed/k3e3SeFnQIM?autoplay=1" title="SPARK81 - Salas de acción arcade" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" autoplay  allowfullscreen></iframe></template>
    </Modal>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex";
import FAQs from "./FAQs.vue";
import Prices from "./Prices.vue";
import Subscribe from "./Subscribe.vue";
import Modal from "./Modal.vue";
export default {
  props: {},
  components: { FAQs, Prices, Subscribe , Modal},
  beforeCreate() {},
  setup(props) {
    const router = useRouter();
    const store = useStore();
    const route = useRoute();
    const roomSelected = ref(0);
    const changeRoomSelected = (room) => {
      roomSelected.value = room;
    };
    const isModalOpened = ref(false);

  const openModal = () => {
    isModalOpened.value = true;
  };
  const closeModal = () => {
    isModalOpened.value = false;
  };

  const rooms = ref([
      {
        name: "SALA DIANAS",
        icon_src: new URL(
          "/src/assets/images/icons-sala(1).png",
          import.meta.url
        ).href,
        room_src: new URL("/src/assets/images/Dianas-min.png", import.meta.url)
          .href,
        challenges: [
          {
            name: "TIRO AL BLANCO",
            description: "Afina tu puntería acertando en el blanco.",
          },
          {
            name: "IMITACIÓN",
            description: "Memoriza una secuencia y repítela.",
          },
          {
            name: "COLORES ESCONDIDOS",
            description: "Memoriza la posición de diferentes colores.",
          },
          {
            name: "RÁFAGA",
            description: "Dispara a las dianas que van saliendo antes de que se apaguen.",
          },
          {
            name: "PLAGIO",
            description: "Reproduce el dibujo que ves en la pantalla atinando en las dianas.",
          },
          {
            name: "PISTOLERO",
            description: "(COMPETITIVO) Dale a las dianas de tu color más rápido que tus compañeros.",
          },
        ],
      },
      {
        name: "SALA BOTONES",
        icon_src: new URL(
          "/src/assets/images/icons-sala(2).png",
          import.meta.url
        ).href,
        room_src: new URL("/src/assets/images/Botones-min.png", import.meta.url)
          .href,
        challenges: [
          {
            name: "REACCIÓN RÁPIDA",
            description: "Pulsa los botones antes de que se apaguen. Cada color funciona de una manera distinta.",
          },
          {
            name: "BUSCA Y CAPTURA",
            description: "Identifica un patrón de colores concreto entre la multitud.",
          },
          {
            name: "HAZ MEMORIA",
            description: "Memoriza la posición de diferentes parejas de colores.",
          },
          {
            name: "APAGÓN",
            description: "Apaga todos los botones por orden de color.",
          },
          {
            name: "TODOS A UNA",
            description: "Pulsa todos los botones de un color a la vez.",
          },
          {
            name: "SECUENCIAS",
            description: "Reproduce la secuencia de colores que ves en pantalla.",
          },
        ],
      },
      {
        name: "SALA MOSAICO",
        icon_src: new URL(
          "/src/assets/images/icons-sala(3).png",
          import.meta.url
        ).href,
        room_src: new URL("/src/assets/images/Mosaico-min.png", import.meta.url)
          .href,
        challenges: [
          {
            name: "CASCADA",
            description: "(COMPETITIVO) Sigue el ritmo para pisar las casillas.",
          },
          {
            name: "TRAVESÍA",
            description: "Llega al destino sin pisar las casillas rojas.",
          },
          {
            name: "PONTE A SALVO",
            description: "Corre hasta el color correcto antes de que se acabe el tiempo.",
          },
          {
            name: "ESQUIVA Y CONQUISTA",
            description: "Pisa las casillas azules sin que te pillen las rojas.",
          },
          {
            name: "GUERRA DE COLORES",
            description: "(COMPETITIVO) Llega a tu color antes que tus compañeros.",
          },
        ],
      },
      {
        name: "SALA JUNGLA",
        icon_src: new URL(
          "/src/assets/images/icons-sala(4).png",
          import.meta.url
        ).href,
        room_src: new URL("/src/assets/images/Jungla-min.png", import.meta.url)
          .href,
        challenges: [
          {
            name: "CAZA SÍMBOLOS",
            description: "(COMPETITIVO) Captura más símbolos que tus compañeros.",
          },
          {
            name: "FRENESÍ",
            description: "Apaga todos los colores lo más rápido posible.",
          },
          {
            name: "INVESTIGACIÓN",
            description: "Responde preguntas sobre los símbolos escondidos en la jungla.",
          },
          {
            name: "CONTRARRELOJ",
            description: "Pasa los objetos por los paneles antes de que termine el tiempo.",
          },
        ],
      },
      {
        name: "SALA GAMING",
        icon_src: new URL(
          "/src/assets/images/icons-sala(5).png",
          import.meta.url
        ).href,
        room_src: new URL("/src/assets/images/Gaming-min.png", import.meta.url)
          .href,
        challenges: [
          {
            name: "BATALLA DE MINIJUEGOS",
            description: "(COMPETITIVO) Competición de minijuegos rápidos.",
          },
          {
            name: "MARATÓN DE DESAFÍOS",
            description: "(COMPETITIVO) Serie de pruebas competitivas.",
          },
          {
            name: "A RITMO",
            description: "Completa las acciones a medida que van bajando.",
          },
          {
            name: "BOMBA",
            description: "Desactiva las bombas antes de que exploten.",
          },
        ],
      },
      {
        name: "SALA RADAR",
        icon_src: new URL(
          "/src/assets/images/icons-sala(6).png",
          import.meta.url
        ).href,
        room_src: new URL("/src/assets/images/Radar-min.png", import.meta.url)
          .href,
        challenges: [
          {
            name: "SERIES",
            description: "Apaga las pantallas siguiendo la serie.",
          },
          {
            name: "A RAJATABLA",
            description: "Consigue que los paneles cumplan todas las reglas.",
          },
          {
            name: "SÍMBOLOS ENCADENADOS",
            description: "Apaga los paneles siguiendo el orden de símbolos.",
          },
          {
            name: "SOPA DE LETRAS",
            description: "(COMPETITIVO) Compite por equipos para apagar las pantallas siguiendo la serie.",
          },
          {
            name: "DUELO CROMÁTICO",
            description: "(COMPETITIVO) Apaga los paneles de tu color.",
          },
        ],
      },
    ]);


    return { rooms, roomSelected, changeRoomSelected , openModal, isModalOpened, closeModal};
  },
};
</script>

